import {
    MIXPANEL_EVENT_PROPERTIES,
    UserStore,
    ReferrerStore,
    BriefStore,
    PagePathStore,
    SimpleStore,
} from '../../../shared/mixpanel';
import { createProjectIdStore } from '../../../shared/mixpanel/stores/projectId';
import { createSellerIdStore } from '../../../shared/mixpanel/stores/sellerId';
import { createVariationIdStore } from '../../../shared/mixpanel/stores/variationId';

const { ORDER_TYPE, FROM_BOOST, USER_ACTIVATED } = MIXPANEL_EVENT_PROPERTIES;

export default {
    user: new UserStore(),
    referrer: new ReferrerStore(),
    brief: new BriefStore({ disableErrorLogging: true }),
    pagePath: new PagePathStore(),
    projectId: createProjectIdStore(),
    variationId: createVariationIdStore(),
    sellerId: createSellerIdStore(),
    orderType: new SimpleStore<typeof ORDER_TYPE, string>(ORDER_TYPE),
    userActivated: new SimpleStore<typeof USER_ACTIVATED, boolean>(
        USER_ACTIVATED
    ),
    fromBoost: new SimpleStore<typeof FROM_BOOST, number>(FROM_BOOST),
};
